// TODO: Multilanguage -> Api admin panel

var lang = {

    error_please_reload_page: "<p>Спробуйте перезавантажити сторінку і зареєструватись ще раз.</p>" +
        "<p>Якщо помилка не зникне, повідомте нас будь ласка на скриньку &lt;admin@lvbs.com.ua&gt;</p>"

};

module.exports = lang;